import { FETCH_NODE_INFO } from '../actions/AdminActions';

// INITIALIZE STATE
const initialState = {
    resourceDependantCount: 1,
    resourceAnalysesCount: 0,
    resourceActiveAnalysisCount: 0,
    resourceDocumentCount: 0,
};

// REDUCER
export const AdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_NODE_INFO}_PENDING`:
            return {
                ...state,
                resourceActiveAnalysisCount: 0,
                resourceDependantCount: 1,
            };
        case `${FETCH_NODE_INFO}_FULFILLED`:
            return {
                ...state,
                resourceDependantCount: action.payload.dependentCount,
                resourceAnalysesCount: action.payload.analysesCount,
                resourceActiveAnalysisCount: action.payload.activeAnalysesCount,
                resourceDocumentCount: action.payload.documentCount,
            };
        default:
            return state;
    }
};
